/* eslint-disable max-len */
import React, {useEffect, useMemo, useState} from 'react';
import {Actions} from '../../../common/actions';
import {useDispatch, useSelector} from 'react-redux';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {Modal, Button, Grid, Popup, Icon} from 'semantic-ui-react';
import './priceColorModal.scss';
import VehicleData from './components/vehicleData';
import SearchFormMany from './components/searchFormMany';
import {convertDateToSpecificFormat} from '../../../common/util/date';
import MaintainanceTable from '../vehiclesPriceColor/table/table';
import {columnsHistoryPrices} from './components/columnsHistoryPrices';
import {paths} from '../../../common/dictionaries/urls';

const {
  fetchActivePriceColor,
  clearHistoryPriceColors,
  fetchHistoryPriceColor,
  navigateTo,
  addMessageBoxError,
} = Actions;

const HistoryColorModal = ({selectedVehicle, selectedProduction, onCloseModal, modalWasOpen}) => {
  const dispatch = useDispatch();
  const permissions = useSelector((state) => state.session.permissions);
  const loading = useSelector((state) => state.vehiclePriceColor.loadingHistory);
  const colorsHistory = useSelector((state) => state.vehiclePriceColor.colorsHistory);

  const [searchParameters, setSearchParameters] = useState({
    'startDate': null,
    'endDate': null,
  });

  useEffect(() => {
    if (!hasAccessPermission(permissions, resources.VehiclesHistoryColor, scopes.See)) {
      dispatch(addMessageBoxError('Petición no procesada, usuario no cuenta con el permiso de visualización.'));
      dispatch(navigateTo(paths.VehiclesMaintenance));
    }
  }, []);

  useEffect(() => {
    setSearchParameters((old) => ({
      ...old,
      'masterCode': selectedVehicle?.masterCode || '',
    }));
  }, [selectedVehicle]);

  const handleSearch = () => {
    const {startDate, endDate} = searchParameters;
    const {masterCode, sfx} = selectedVehicle;
    const parseInitDate = convertDateToSpecificFormat(startDate, 'YYYY-MM');
    const parseEndDate = convertDateToSpecificFormat(endDate, 'YYYY-MM');
    const data = {
      'masterCode': masterCode,
      'sfx': sfx,
      'startDate': parseInitDate,
      'endDate': parseEndDate,
    };
    if (parseInitDate > parseEndDate) {
      dispatch(addMessageBoxError(
        'Petición no procesada, el mes de la fecha final debe de ser mayor al mes de la fecha inicial.'));
      return;
    }
    dispatch(fetchHistoryPriceColor(data));
  };

  const onCloseModalClick = () => {
    const {masterCode, sfx} = selectedVehicle;
    const startDate = selectedProduction;
    let formattedDate = '';
    if (startDate) {
      const [month, year] = startDate.split('/');
      formattedDate = `${year}-${month}`;
    }
    const data = {
      'masterCode': masterCode,
      'sfx': sfx,
      'startDate': formattedDate,
    };
    selectedProduction && dispatch(fetchActivePriceColor(data));
    dispatch(clearHistoryPriceColors());
    onCloseModal();
  };

  const handleChange = (field, value) => {
    setSearchParameters((old) => ({
      ...old,
      [field]: value,
    }));
  };

  const data = useMemo(
    () => colorsHistory, [colorsHistory]
  );
  const columns = useMemo(
    () => columnsHistoryPrices(),
    []);

  return (
    <Modal size={'fullscreen'} className='stock-download-modal' open={modalWasOpen}>
      <Modal.Header>
        Historial de Colores del Vehículo: {selectedVehicle.masterCode}
        <Popup
          trigger={
            <Icon link name='info circle' color='red' size='large' />
          }
          on='click'
          position='bottom left'
          inverted
        >
          <div>
            Pantalla de configuración de colores que será utilizado para el maestro de vehículos
          </div>
        </Popup>
      </Modal.Header>
      <Modal.Content scrolling>
        <Modal.Description className='toyota-table-body'>
          <div className='title-bar'>
            <div className='filters-section'>
              <Grid textAlign='left'>
                <VehicleData selectedVehicle={selectedVehicle}/>
                <Grid.Row>
                  <SearchFormMany
                    {...searchParameters}
                    handleChange={handleChange}
                    columns={columns}
                    data={data || []}
                    loading={loading}
                  />
                  <Grid.Column width={3}>
                    <Button
                      primary
                      className='toyota-primary'
                      disabled={!searchParameters.startDate || !searchParameters.endDate}
                      onClick={handleSearch}
                      type="submit"
                    >
                        BUSCAR
                    </Button>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </div>
          <MaintainanceTable
            columns={columns}
            data={data || []}
            loading={loading}
          />
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onCloseModalClick}>
          Cancelar
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default HistoryColorModal;
